import { sanitizeRichTextHtml } from '../../utils/sanitizeHtml';
// TranslationModal.tsx
// NOTE: Update frontend/src/Admin/AITesting/__tests__/TranslationModal.test.tsx and run
// `../scripts/npm-local.sh test -- TranslationModal --watch=false` whenever modifying this modal.
import React from 'react'
import { Modal, Tabs, Input } from 'antd'

const { TextArea } = Input

interface TranslationModalProps {
  visible: boolean
  content: string
  onClose: () => void
}

const TranslationModal: React.FC<TranslationModalProps> = ({ visible, content, onClose }) => {
  return (
    <Modal
      title="Translation"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Tabs defaultActiveKey="raw">
        <Tabs.TabPane tab="Raw" key="raw">
          <TextArea rows={12} value={content} readOnly />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Rendered" key="rendered">
          <div
            data-testid="translation-rendered-html"
            style={{
              padding: 16,
              border: '1px solid #f0f0f0',
              borderRadius: 4,
              minHeight: 300,
              backgroundColor: 'var(--surface-muted)',
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(content) }}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

export default TranslationModal
